import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { makeFormField, chooseRandom, removeLargeNumbers } from '@/helpers';

const NAMES = [
  'The Best Ever',
  'Whole Lotta of Love',
  'Hunger Slayer',
  'Hungry No More',
  'Worth It',
  'Treating Myself',
  'The Good Stuff',
  'The Best Meal Ever',
  'Instant Gratification',
  'Overstuffed Goodness',
  'Food Life Forever',
  'Foiled Again',
  'My Epic Meal',
  'Just Delicious',
  'Flavor City',
  'My Day Is Made',
  'Real Meal Deal',
  `Dang That's Good`,
  'Time to Chow Down',
  'My True Love',
  'Pure Bliss',
  'Happy Time',
  'Happy Town',
  'Hello Beautiful',
  'Goodbye Hunger',
  'Lucky Me',
  'Good Eats',
  'Real Tasty',
  'Sweet Dreamer',
  'Heart My Food',
  'Food Me Now',
  'Happiness Now',
  'True Happiness',
  'Feed The Beast',
  'Foil Me Up',
  'My Favorite Thing',
  'Epic Eats',
  'Keeping It Real',
  'Tasty Time',
  'I Love This One',
  'The Best Ever',
  'Happy Dance',
  'My Happy Place',
  'This Is So Good',
  'What I Want',
  'Good For Me',
  `That's Good`,
  'Good Choices',
  'Best Part My Day',
  'Shiny Foil',
  'I Have Good Taste',
  'My Food Baby',
  'Heck Yes',
  'Food Goals',
  'Dreamy Food',
  'Ridiculously Tasty',
  'Hot Sauce Boss',
  'My Comfort Food',
  'Munchie Goodness',
  'Food For Thought',
  'Feast Mode',
  'The Supreme Bean',
  'Destroying Hunger',
  'Ruler of the Stomach',
  'Drool Worthy',
  'All I Ever Wanted',
  'Turbocharge This',
  'My Favorite Things',
  'Getting Saucy',
  'My Go To',
  'The Usual',
];

@Component({
  name: 'CmgAddFavoriteOrderModal',
})
export default class CmgAddFavoriteOrderModal extends Vue {
  readonly maxNameLength = 50;

  name = makeFormField();
  saving = false;

  get args() {
    return this.$appStore.state.ui.modals.addFavoriteOrder.args;
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.addFavoriteOrder.visible;
  }

  get refreshIconUrl(): string {
    return this.$appStore.state.cms.images.icons.refresh.default;
  }

  @Watch('visible', { immediate: true })
  onVisibleUpdated() {
    this.name.value = this.getRandomName();
  }

  close() {
    this.$services.ui.setModalVisibility('addFavoriteOrder', false);
    Vue.nextTick(() => {
      setTimeout(() => {
        this.$services.ui.focusBack();
      }, 1000);
    });
  }

  getRandomName() {
    this.name.error = null;
    return chooseRandom(NAMES);
  }


  removeLargeNumbersFavoriteName(){
    const favoriteName1 = this.name;
    let favoriteNameClean = removeLargeNumbers(favoriteName1.value);
    this.name.value = favoriteNameClean;
  }
   
  sanitizeFavoriteName(value: string) {
    return value.slice(0, this.maxNameLength);
  }


  async onClickSave() {
    const order = this.args && this.args.order;
    if (!order || this.name.error) {
      // TODO-p9x357: what do?
      return;
    }

    this.saving = true;

    try {
      order.favoriteName = this.name.value;
      await this.$services.recentAndFavoriteOrders.addRecentOrderToFavorites(order, order.favoriteName);
    } catch (e) {
      // TODO-qk4bsv: what do?
      this.$services.logger.error('Something went wrong while adding adding new favorite order', undefined, e);
    } finally {
      this.saving = false;
    }

    this.close();
  }

  onClickRefresh(event: any) {
    this.name.value = this.getRandomName();
    Vue.nextTick(() => {
      setTimeout(() => {
        const focusNearby = document.getElementsByClassName('refreshTxt')[0] as HTMLElement;
        if (focusNearby) {
          const focusFirstelement = focusNearby.getElementsByClassName('input')[0] as HTMLInputElement;
          focusFirstelement.select();
          focusFirstelement.focus();
          focusFirstelement.setSelectionRange(0, focusFirstelement.value.length);
        }
      }, 0);
    });
  }
}
